import React from 'react';
import { utilizationApi } from '../../../services';
import { OverallManager } from '../../../managers/DoctorConsultationManager';
import { GraphCard } from '../../common/organisms';
import { handleAppError } from '../../handlers';

class OverallSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overallObj: {},
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchOverallData();
  }

  componentWillUnmount() {
    this.props.token && this.props.token.cancel();
  }

  fetchOverallData = () => {
    const { contractId, token } = this.props;

    var promise1 = utilizationApi.doctorFetchOverall({ contractId, cancelToken: token.token });
    var promise2 = utilizationApi.doctorFetchOverallAvgWaitTime({ contractId, cancelToken: token.token });
    var promise3 = utilizationApi.doctorFetchOverallRepeatedUsers({ contractId, cancelToken: token.token });
    var promise4 = utilizationApi.doctorFetchOverallRatings({ contractId, cancelToken: token.token });
    var promise5 = utilizationApi.fetchContracts({})
    Promise.all([promise1, promise2, promise3, promise4, promise5])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var overallObj = new OverallManager(resp_arr);
        this.setState({ overallObj, loading: false });
      })
      .catch((err) => {
        handleAppError(err);
      });
  };
  calculateHeight(data) {
    if (data) {
      let length;
      data.length < 10 ? (length = data.length * 110 + 'px') : (length = data.length * 70 + 'px');
      return length;
    }
  }
  render() {
    const { overallData = {}, ratingsData = {}, avgWaitTimeData = {}, repeatUsersData = {} } = this.state.overallObj;
    const { loading } = this.state;

    return (
      <div className='pt-8'>
        <span className='block font-semibold text-base text-gray-600 mb-3 leading-none'>
          Consultation across the years
        </span>
        <div style={{ height: this.calculateHeight(overallData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'DoctorConsultationBarGraph',
              data: overallData.data,
              labels: overallData.labels,
              backgroundColor: overallData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 4 * overallData.stepSize || 5,
                stepSize: overallData.stepSize || 1,
              },
              xAxesLabel: 'Number of doctor consultation',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={overallData.content}
          />
        </div>
        <span className='block font-semibold text-base text-gray-600 mb-3 mt-12 leading-none'>
          Average wait time across the years
        </span>
        <div style={{ height: this.calculateHeight(avgWaitTimeData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'AverageWaitTimeBarGraph',
              data: avgWaitTimeData.data,
              labels: avgWaitTimeData.labels,
              backgroundColor: avgWaitTimeData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 5 * avgWaitTimeData.stepSize || 5,
                stepSize: avgWaitTimeData.stepSize || 1,
              },
              xAxesLabel: 'Wait time (in seconds)',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={avgWaitTimeData.content}
          />
        </div>
        <span className='block font-semibold text-base text-gray-600 mb-3 mt-12 leading-none'>Repeat users</span>
        <div style={{ height: this.calculateHeight(repeatUsersData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'RepeatUsersBarGraph',
              data: repeatUsersData.data,
              labels: repeatUsersData.labels,
              backgroundColor: repeatUsersData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 0,
                max: 5 * repeatUsersData.stepSize || 5,
                stepSize: repeatUsersData.stepSize || 1,
              },
              xAxesLabel: 'Number of repeat users',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={repeatUsersData.content}
          />
        </div>
        <span className='block font-semibold text-base text-gray-600 mb-3 mt-12 leading-none '>
          Doctor consultation ratings
        </span>
        <div style={{ height: this.calculateHeight(ratingsData.data) }}>
          <GraphCard
            loading={loading}
            loaderHeight={200}
            graphprops={{
              id: 'ratingsBarGraph',
              data: ratingsData.data,
              labels: ratingsData.labels,
              backgroundColor: ratingsData.barColors,
              type: 'horizontalBar',
              ticks: {
                min: 1,
                max: 5,
                stepSize: 1,
              },
              xAxesLabel: 'Ratings',
              yAxesLabel: 'Contract years',
            }}
            descriptionPoints={ratingsData.content}
          />
        </div>
      </div>
    );
  }
}
export default OverallSection;
